
import { SaleType } from "@/models/base";
import { SaleService } from "@/services/sale-service";
import { UserConfigService } from "@/services/user-config-service";
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
import AppSaleTypeList from "@/components/settings-sales/SaleTypeList.vue";

export default Vue.extend({
	data() {
		return {
			types: [] as SaleType[],
			purchaseTypes: [] as SaleType[],
			createNew: false,
			newIsPurchase: false
		};
	},
	computed: {
		path(): IBreadCrumb[] {
			return [
				{
					to: "/settings/sales",
					value: this.$ct("sale/purchase")
				},
				{
					value: this.$ct("per-type")
				}
			] as IBreadCrumb[];
		},
	},
	methods: {
		setSaleOrder(){
			let settings = UserConfigService.getSaleSettings();
			settings.SaleDisplayOrder = this.types.map(t=>t.ID);
			UserConfigService.setSaleSettings(settings);
		},
		setPurchaseOrder(){
			let settings = UserConfigService.getSaleSettings();
			settings.PurchaseDisplayOrder = this.purchaseTypes.map(t=>t.ID);
			UserConfigService.setSaleSettings(settings);
		},
		openCreateModal(isPurchaseType:boolean) {
			this.newIsPurchase = isPurchaseType;
			this.createNew = true;
		},
		onNewCreated(saleType:SaleType){
			this.$router.push(`/settings/sales/types/${saleType.ID}`);
		},
		async deleteType(saleType:SaleType){
			let confirm = await this.$confirmBuilder(this.$ct("are-you-sure-you-want-to-delete-sale-type", {text: saleType.DisplayedName})).setWarningTitle().show();
			if (!confirm) return;
			await SaleService.deleteType(saleType);
			this.init();
		},
		refresh(){
			this.init();
		},
		init(){
			this.types = SaleService.getTypes(1);
			this.purchaseTypes = SaleService.getTypes(2);
		}
	},
	mounted() {
		this.init();
	},
	components: {
		AppSaleTypeList
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
